import cn from 'classnames';
import React from 'react';
import styled from 'styled-components';
import Button from "../../../components/button/Button";

const Styled = styled.div``;
const CheckIn = props => {
  return (
    <Styled className={cn('check-in')} >
      <Button size="large">Check In</Button>
    </Styled>
  );
};

export default CheckIn;
